module.exports = __webpack_public_path__ + "img/1 (120).9660e721.png";